@if (showBanner()) {
  <div class="cookie-consent-banner" role="dialog" aria-modal="false" aria-labelledby="cookieConsentTitle">
    <div class="consent-content">
      <h4 id="cookieConsentTitle">Cookie &amp; Tracking Consent</h4>
      <p>
        We use cookies and analytical/marketing tracking technologies (including Google Analytics, Bing, and Facebook) to optimize your search experience, measure site traffic, and personalize recommendations under the Digital Personal Data Protection Act (DPDP). Click "Accept All" to consent, or "Decline" to continue without tracking.
      </p>
      @if (isRevisiting() && currentChoice()) {
        <p class="consent-current">
          Your current choice:
          <strong>{{ currentChoice() === 'true' ? 'Accepted' : 'Declined' }}</strong>.
          You can change it at any time.
        </p>
      }
    </div>
    <div class="consent-actions">
      @if (isRevisiting()) {
        <button class="btn-close-consent" (click)="close()" aria-label="Close cookie settings without changing your choice">Close</button>
      }
      <button class="btn-decline" (click)="declineAll()">Decline</button>
      <button class="btn-accept" (click)="acceptAll()">Accept All</button>
    </div>
  </div>
}
